import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router);

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('./views/Home/Home.vue')
    },
    {
      path: '/product',
      name: 'product',
      meta: { requiresAuth: true, title: '产品与服务'  },
      component: () => import('./views/Product/Product2.vue')
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      meta: { requiresAuth: true, title: '关于我们'  },
      component: () => import('./views/AboutUs/AboutUs.vue')
    },
    // {
    //   path: '/idea',
    //   name: 'idea',
    //   meta: { requiresAuth: true, title: '企业理念'  },
    //   component: () => import('./views/Idea/Idea.vue')
    // },
    // {
    //   path: '/team',
    //   meta: { requiresAuth: true, title: '精英团队'},
    //   component: () => import('./views/Team/Team.vue'),
    //   children:[
    //     { path:'',redirect: '/TeamList'},
    //     { path: '/TeamList', name: 'TeamList',meta: { requiresAuth: true, title: '精英团队' }, component: () => import(`./views/TeamList/TeamList.vue`) },
    //     { path: '/TeamDetail', name: 'TeamDetail',meta: { requiresAuth: true, title: '详情介绍' }, component: () => import(`./views/TeamDetail/TeamDetail.vue`) }
    //   ]
    // },
    {
      path: '/propaganda',
      name: 'propaganda',
      meta: { requiresAuth: true, title: '宣传视频' },
      component: () => import('./views/Propaganda/Propaganda.vue'),

    },
    {
      path: '/dynamic',
      name: 'dynamic',
      meta: { requiresAuth: true, title: '新闻动态' },
      component: () => import('./views/Dynamic/Dynamic.vue')
    },
    {
      path: '/joinUs',
      meta: { requiresAuth: true, title: '加入我们' },
      component: () => import('./views/JoinUs/JoinUs.vue'),
      children:[
        { path:'',redirect: '/JoinUsPart'},
        { path: '/JoinUsPart', name: 'JoinUsPart',meta: { requiresAuth: true, title: '加入我们 ' }, component: () => import('./views/JoinUsPart/JoinUsPart.vue') },
        { path: '/JobDetail', name: 'JobDetail',meta: { requiresAuth: true, title: '职位详情' }, component: () => import(`./views/JobDetail/JobDetail.vue`) },
      ]
    },
    {
      path: '/NewDetail',
      name: 'NewDetail',
      meta: { requiresAuth: true, title: '新闻详情' },
      component: () => import('./views/NewDetail/NewDetail.vue')
    },
    {
      path: '/ProductDetail',
      name: 'ProductDetail',
      meta: { requiresAuth: true, title: '产品详情' },
      component: () => import('./views/ProductDetail/ProductDetail.vue')
    },
    {
      path:'*',
      redirect: '/home'
    }
  ]
});
// router.beforeEach((to,from ,next)=>{
//   // console.log(to);
//   // console.log(from);
//   next();
// })
export default router

